import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Button, Checkbox } from "@akuna/ui";
import { Label } from "@/components/ui/label";
import type { PrintLayoutFormValues, PrintScope } from "../printLayoutForm";
import { PanelShell } from "./PanelShell";

export function SignaturePanel({ onPreviewDigital, scope }: { onPreviewDigital: () => void; scope: PrintScope }) {
  const { t } = useTranslation("settings");
  const { watch, setValue } = useFormContext<PrintLayoutFormValues>();

  return (
    <PanelShell title={t("printEditor.areas.sign")}>
      {scope === "prescription" ? (
        <div className="flex flex-col gap-0.5">
          <p className="text-[13.5px] font-medium">{t("printEditor.sign.printed")}</p>
          <p className="text-xs text-muted-foreground">{t("printEditor.sign.printedHint")}</p>
        </div>
      ) : null}

      <div role="group" aria-labelledby="print-stamp-label" className="flex flex-col gap-2.5">
        <Label id="print-stamp-label">{t("printEditor.sign.stamp")}</Label>
        <Checkbox
          label={t("printEditor.sign.crmv")}
          checked={watch("stampShowCrmv")}
          onCheckedChange={(v) => setValue("stampShowCrmv", v, { shouldDirty: true })}
        />
        <Checkbox
          label={t("printEditor.sign.mapa")}
          checked={watch("stampShowMapa")}
          onCheckedChange={(v) => setValue("stampShowMapa", v, { shouldDirty: true })}
        />
      </div>

      {scope === "prescription" ? (
      <div className="flex flex-col gap-2 rounded-xl bg-state-success-soft p-3">
        <p className="text-[13.5px] font-semibold">{t("printEditor.sign.digitalTitle")}</p>
        <p className="text-xs text-muted-foreground">{t("printEditor.sign.digitalHint")}</p>
        <Button type="button" variant="outline" size="sm" className="self-start" onClick={onPreviewDigital}>
          {t("printEditor.sign.seeDigital")}
        </Button>
      </div>
      ) : null}
    </PanelShell>
  );
}
